<template>
  <v-app class="run-transfer">
    <v-main>
      <v-container>
        <template v-if="loading">
          <div class="text-center mt-5">
            <v-progress-circular color="secondary" indeterminate size="80" width="3"></v-progress-circular>
          </div>
        </template>
        <template v-else>
          <div>
            <v-row align="center" justify="center">
              <v-card :elevation="2" :max-width="500" :min-width="500" class="mb-0 mt-5 mb-1" flat>
                <v-card-text class="py-2" style="background-color: #1D46D2">
                  <v-row justify="center">
                    <v-col cols="12" sm="6">
                      <v-img :max-width="110" src="/logo.png"></v-img>
                    </v-col>
                    <v-col cols="12" sm="6">
                      <div class="white--text text-right body-1">
                        {{ $moment().format('MMM Do YYYY, H:mm:ss') }} CM
                      </div>
                    </v-col>
                  </v-row>
                </v-card-text>
                <v-card-text class="mt-0">
                  <div class="d-block mb-3">
                    <v-img :max-height="35" :max-width="60" class="mb-2" src="/img/momo.png"></v-img>
                    <v-divider></v-divider>
                  </div>
                  <div class="mt-0 mb-2 pb-0">
                    <v-row class="mb-1">
                      <v-col class="py-0 pr-0" cols="2">
                        <div class="body-2 font-weight-bold grey--text text--darken-3">{{
                          $vuetify.lang.t('$vuetify.transfer.cols.enterprise.title') }}:
                        </div>
                      </v-col>
                      <v-col class="py-0" cols="10">
                        <div><span class="grey--text body-1 text--darken-2">{{ user.fullName }}</span></div>
                      </v-col>
                    </v-row>
                    <v-row class="mb-1">
                      <v-col class="py-0 pr-0" cols="2">
                        <div class="body-2 font-weight-bold grey--text text--darken-3">{{
                          $vuetify.lang.t('$vuetify.transfer.cols.service.title') }}:
                        </div>
                      </v-col>
                      <v-col class="py-0" cols="10">
                        <div><span class="grey--text body-1 text--darken-2">{{ user.fullName }}</span></div>
                      </v-col>
                    </v-row>
                    <v-row class="mb-1">
                      <v-col class="py-0 pr-0" cols="2">
                        <div class="body-2 font-weight-bold grey--text text--darken-3">{{
                          $vuetify.lang.t('$vuetify.transfer.cols.accountNumber.title2') }}:
                        </div>
                      </v-col>
                      <v-col class="py-0" cols="10">
                        <div><span class="grey--text body-1 text--darken-2">{{ user.phone }}</span></div>
                      </v-col>
                    </v-row>
                    <v-row class="mb-2">
                      <v-col class="py-0 pr-0" cols="2">
                        <div class="body-2 font-weight-bold grey--text text--darken-3">{{
                          $vuetify.lang.t('$vuetify.transfer.cols.address.title') }}:
                        </div>
                      </v-col>
                      <v-col class="py-0" cols="10">
                        <div><span class="grey--text body-1 text--darken-2">{{ user.address }}</span></div>
                      </v-col>
                    </v-row>
                  </div>
                  <div>
                    <v-divider></v-divider>
                    <v-list two-line>
                      <v-subheader class="transfer-headline font-weight-bold grey--text text--darken-3">{{
                        $vuetify.lang.t('$vuetify.transfer.info.title') }}
                      </v-subheader>
                      <v-list-item class="list-item" link>
                        <v-list-item-avatar>
                          <v-icon class="blue-grey--text">mdi-apps</v-icon>
                        </v-list-item-avatar>
                        <v-list-item-content>
                          <v-list-item-title class="body-2 blue-grey--text font-weight-bold">{{ transfer.appName }}
                          </v-list-item-title>
                          <v-list-item-subtitle class="body-1">{{
                            $vuetify.lang.t('$vuetify.transfer.cols.application.title') }}
                          </v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                      <v-list-item class="list-item" link>
                        <v-list-item-avatar>
                          <v-icon class="blue-grey--text">mdi-cash</v-icon>
                        </v-list-item-avatar>
                        <v-list-item-content>
                          <v-list-item-title class="body-2 blue-grey--text font-weight-bold">{{ transfer.amount }}
                          </v-list-item-title>
                          <v-list-item-subtitle class="body-1">{{
                            $vuetify.lang.t('$vuetify.transfer.cols.amount.title') }}
                          </v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                      <v-list-item class="list-item" link>
                        <v-list-item-avatar>
                          <v-icon class="blue-grey--text">mdi-bank-outline</v-icon>
                        </v-list-item-avatar>
                        <v-list-item-content>
                          <v-list-item-title class="body-2 blue-grey--text font-weight-bold">
                            <template v-if="transfer.type">
                              {{
                              $vuetify.lang.t('$vuetify.transactions.' + transfer.type) }}
                            </template>
                          </v-list-item-title>
                          <v-list-item-subtitle class="body-1">{{
                            $vuetify.lang.t('$vuetify.transfer.cols.transaction.title2') }}
                          </v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                      <v-list-item class="list-item" link>
                        <v-list-item-avatar>
                          <v-icon class="blue-grey--text">mdi-wallet-outline</v-icon>
                        </v-list-item-avatar>
                        <v-list-item-content>
                          <v-list-item-title class="body-2 blue-grey--text font-weight-bold">{{ transfer.account_number
                            }}
                          </v-list-item-title>
                          <v-list-item-subtitle class="body-1">{{
                            $vuetify.lang.t('$vuetify.transfer.cols.accountNumber.title') }}
                          </v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </div>
                </v-card-text>
              </v-card>
            </v-row>
            <v-row align="center" justify="center">
              <v-card :elevation="2" :max-width="500" :min-width="500" class="mb-1" flat>
                <v-card-text class="py-1">
                  <v-row justify="center">
                    <v-col cols="7">
                      <span class="title text-uppercase">{{ $vuetify.lang.t('$vuetify.transfer.info.title2') }}</span>
                    </v-col>
                    <v-col cols="5">
                      <div class="text-right title">{{ transfer.amount }} FCFA</div>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-row>
            <v-row align="center" justify="center">
              <v-card :elevation="0" :max-width="500" :min-width="500" class="mb-1" color="#F9F9F9" flat>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn :elevation="1" @click="$router.push({name: 'transfer'})" large>{{
                    $vuetify.lang.t('$vuetify.btn.cancel') }}
                  </v-btn>
                  <v-btn :elevation="1" :loading="loadingBtn" @click="sendForm" color="primary" large>{{
                    $vuetify.lang.t('$vuetify.transfer.btn.save.title') }}
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-row>
          </div>
          <div class="mb-9">
            <v-footer :elevation="2" class="grey lighten-4 pa-3" fixed>
              <div>
                <v-img :max-width="85" src="/img/logo-grey.png"></v-img>
              </div>
              <v-spacer></v-spacer>
              <div class="grey--text text--lighten-1">
                <strong>{{ $moment().format('© YYYY')}}</strong>
              </div>
            </v-footer>
          </div>
        </template>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
  import FormMixin from '../../mixins/Common/Forms';
  import URLPath from "../../helpers/URL";
  import Utils from "../../helpers/Utils";

  export default {
    mixins: [FormMixin],
    data: () => ({
      loading: true,
      loadingBtn: false,
      transfer: {},
      user: {
        fullName: "",
        phone: "",
        address: ""
      }
    }),
    created() {
      if (!this.$route.params.appSlug) this.$router.push({name: "notfound"});
      if (!this.$cookies.isKey(Utils.getTesterTransferCookieName())) this.$router.push({name: "notfound"});
      if (this.$auth.user()) {
        const data = this.$cookies.get(Utils.getTesterTransferCookieName());
        this.transfer = data;
        if (this._.isEmpty(data)) this.$router.push({name: "notfound"});
        this.$cookies.remove(Utils.getTesterTransferCookieName());
        if (this.$auth.user().role !== "ROLE_CLIENT") {
          if (!this._.has(data, "userId")) {
            this.$router.push({name: "notfound"});
          } else {
            this.getUser(data["userId"]);
          }
        } else {
          this.user = {
            fullName: this.$auth.user().profile.fullName,
            phone: this.$auth.user().profile.phone,
            address: this.$auth.user().profile.address
          }
        }
      } else {
        this.$router.push({name: "notfound"});
      }
    },
    methods: {
      getUser(userId) {
        const self = this;
        let params = {};
        params["url"] = URLPath.USER.GET.URI.replace("{USER_ID}", userId);
        params["method"] = URLPath.USER.GET.METHOD;
        self.loading = true;
        this.save(params)
          .then((response) => {
            const data = response.data;
            self.user = {
              fullName: data["profile"]["fullName"],
              phone: data["profile"]["phone"],
              address: data["profile"]["address"]
            };
            self.loading = false;
          }).catch(() => {
          self.$router.push({name: "notfound"})
        }).finally();
      },
      sendForm() {
        let self = this;
        this.loadingBtn = true;
        this.save(this.getFormParam())
          .then(() => {
            self.$router.push({name: 'transfer'});
          }).catch((err) => {
          if (err.response) {
            if (err.response.status === 400) {
              self.$store.dispatch("setNotification", {
                status: true,
                message: err.response.data["message"]
              });
            }
          }
        }).finally(() => {
          self.loadingBtn = false;
        })
      },
      getFormParam() {
        let params = {};
        params["url"] = URLPath.TESTER.TRANSFER.INIT.URI;
        params["method"] = URLPath.TESTER.TRANSFER.INIT.METHOD;
        params["data"] = this._.omit(this.transfer, ['userId', 'appName']);
        return params;
      }
    }
  }
</script>

<style scoped>

  .v-application .body-1 {
    font-size: 1rem !important;
    font-weight: 400 !important;
    letter-spacing: .03125em !important;
    line-height: 1.5rem !important;
  }

  .v-application .text-right {
    text-align: right !important;
  }

  .v-application .white--text {
    color: #fff !important;
    caret-color: #fff !important;
  }

  .run-transfer {
    font-size: 13px;
    font-family: Josefin Sans, sans-serif;
    background-color: #F9F9F9;
    color: #000;
  }

  .v-application .blue-grey--text {
    color: #607d8b !important;
    caret-color: #607d8b !important;
  }

  .v-icon.v-icon {
    font-size: 24px !important;
  }

  .transfer-headline {
    font-size: 1.2rem !important;
  }

  .v-application .grey.lighten-4 {
    background-color: #f5f5f5 !important;
    border-color: #f5f5f5 !important;
  }

  .v-application .mt-2 {
    margin-top: 8px !important;
  }

  .list-item {
    min-height: 55px !important;
    height: 55px !important;
  }

</style>
